// Override Settings
var bcSfSearchSettings = {
    search: {
        //suggestionMode: 'test'
        //suggestionPosition: 'left'
    }
};

// Customize style of Suggestion box
BCSfFilter.prototype.customizeSuggestion = function(suggestionElement, searchElement, searchBoxId) {
};

BCSfFilter.prototype.getSearchTerm = function() {  	  	
	var term = getParam(this.searchTermKey);
  	term = term.replace(/\+/g, '');
  
  	
    return term;
};

BCSfFilter.prototype.customizeSearchTerm = function(searchTerm) {
    return encodeURIParamValue(searchTerm.replace(/\+/g, '').trim());
};
